<template>
  <div v-if="isOpen">
    <div class="modal fade" role="dialog" ref="extraModal">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body repricing-modal">
            <div class="row">
              <div class="col-sm-12">
                <div class="col-sm-12">
                  <div class="d-flex justify-between items-center">
                    <h4 style="font-weight: 800">Edit Trip Log</h4>
                    <button
                      type="button"
                      class="close btn-close-modal"
                      data-dismiss="modal"
                      aria-label="Close"
                      @click="closeModal()"
                    >
                      <i class="ic-close"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <form @submit.prevent="onSubmit" style="margin-top: 20px">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="required">Date</label>
                      <VueCtkDateTimePicker
                        v-model="form.date"
                        label="Select date"
                        id="date"
                        color="#025BC5"
                        format="YYYY-MM-DD"
                        formatted="MMM DD, YYYY"
                        :min-date="disabledDates"
                        auto-close
                        only-date
                        no-label
                        no-header
                        no-button
                        no-button-now
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <template>
                        <label class="required">Time</label>
                        <span class="utc-zone">({{ timeZone }})</span>
                      </template>
                      <VueCtkDateTimePicker
                        v-model="form.time"
                        label="Select time"
                        id="time"
                        color="#025BC5"
                        format="HH:mm"
                        formatted="HH:mm"
                        only-time
                        no-label
                        no-header
                        no-button
                        no-button-now
                      />
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="d-flex justify-end gap-10 items-center">
                      <!-- <button type="reset" class="btn btn-cancel">Reset</button> -->
                      <button type="submit" class="btn btn-submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loader :content="msg" :visible="isLoading" />
  </div>
</template>
<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      isOpen: false,
      isLoading: false,
      msg: "Please wait",
      isSubmitted: false,
      form: {
        id: "",
        date: "",
        time: "",
        description: "",
      },
      timeZone: "",
      disabledDates: null,
    };
  },
  validations() {
    const v = {
      form: {
        id: { required },
        date: { required },
        time: { required },
        description: {},
      },
    };

    return v;
  },
  created() {
    this.$eventBus.$on("FormEditLogging", this.initialize);
  },
  beforeDestroy() {
    this.$eventBus.$off("FormEditLogging");
  },
  methods: {
    initialize(data, pickUpDateTime, userType) {
      this.isLoading = true;
      this.isOpen = true;

      const date = moment(pickUpDateTime.dateTime);

      if (userType === "TenantUser") {
        const disabledDates = date.subtract(1, "days");
        this.disabledDates = disabledDates.format("YYYY-MM-DD");
      } else {
        this.disabledDates = date.format("YYYY-MM-DD");
      }

      this.timeZone = data.timeStamp.timezone;

      // let utc;
      // if (this.timeZone.includes("+")) {
      //   utc = `+${this.timeZone.split("+")[1]}`;
      // }

      // if (this.timeZone.includes("-")) {
      //   utc = `+${this.timeZone.split("-")[1]}`;
      // }

      const originalDate = moment(data.timeStamp.dateTime);
      // const adjustedDate = originalDate.utcOffset(utc);

      // const formattedDate = adjustedDate.format("YYYY-MM-DD");
      // const formattedTime = adjustedDate.format("HH:mm");

      const formattedDate = originalDate.parseZone().format("YYYY-MM-DD");
      const formattedTime = originalDate.parseZone().format("HH:mm");

      this.form = {
        id: data.id,
        date: formattedDate,
        time: formattedTime,
        description: data.description,
      };
      setTimeout(() => {
        $(this.$refs.extraModal).modal({
          backdrop: "static",
          keyboard: false,
        });
        this.isLoading = false;
      }, 1000);
    },
    onSubmit() {
      this.isSubmitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.$nextTick(() => this.$helper.focusToFieldError());
        return;
      }
      this.$emit("submit", this.form);
      this.closeModal();
    },
    closeModal() {
      this.isOpen = false;
      this.isSubmitted = false;
      $(this.$refs.extraModal).modal("hide");
    },
  },
  updated() {
    this.$helper.numbersOnly();
  },
};
</script>
<style scoped>
.modal-body.repricing-modal {
  padding: 15px 20px;
}
.btn.btn-submit {
  background: #4fb848;
  font-size: 0.8667rem;
  border-radius: 5px;
  border: transparent;
  font-weight: 900;
  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 2px 8px -5px #4c4c4c;
  box-shadow: 0px 2px 8px -5px #4c4c4c;
  color: #fff;
  padding: 10px 20px;
  text-transform: uppercase;
  outline: none;
}
.btn.btn-cancel {
  background: #a0a0a0;
  font-size: 0.8667rem;
  border-radius: 5px;
  border: transparent;
  font-weight: 900;
  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 2px 8px -5px #4c4c4c;
  box-shadow: 0px 2px 8px -5px #4c4c4c;
  color: #fff;
  padding: 10px 20px;
  text-transform: uppercase;
  outline: none;
}
.btn.btn-submit:hover {
  background: #339c2b;
}
.btn.btn-cancel:hover {
  background: #888888;
}
.gap-10 {
  gap: 10px;
}
.utc-zone {
  color: #939396;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/FormEditLogging.vue